module.exports = require("./ak-GH.js");